<template>
    <div class="button-layout"><slot></slot></div>
</template>